import React from 'react';
import '../css/Home.css'
import eu from "../images/eu.jpeg"

import { AiOutlineCoffee } from 'react-icons/ai';


function Home(){
    return(
        <div className='containerHome'>
            <aside className='left'>
                <img src={eu} alt="minha foto" className='img' />
                <p className='title'>DEV JUNIOR</p>
            </aside>
            <div className='sticky'>
                <div id='ball1'></div>
                <div id='ball2'></div>
            </div>
            <aside className='rigth'>
                <h1 className='title'>Douglas Bento</h1>
                <p className='subtitle'>Douglas Arthur da Silva Bento</p>
                <p>
                    Olá prazer! Bem vindo ao meu portfólio, sou um iniciante e entusiada no mundo dev,
                     sou estudante do Instituto Federal de Educação, Ciência e Tecnologia de Rôndonia (IFRO),
                      pesquisador do grupo de pesquisa GP mecatronica, desenvolvendo um treinamento para a Olimpiáda Brasileira
                     de Informática (OBI). E como todo T.I, eu gosto muito de café. <AiOutlineCoffee size={20}/>
                </p>
                
                
            </aside>
        </div>
    );
}

export default Home;